import { render, staticRenderFns } from "./DetailsList.vue?vue&type=template&id=1253ea7e&scoped=true"
import script from "./DetailsList.vue?vue&type=script&lang=js"
export * from "./DetailsList.vue?vue&type=script&lang=js"
import style0 from "./DetailsList.vue?vue&type=style&index=0&id=1253ea7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1253ea7e",
  null
  
)

export default component.exports